module.exports = __webpack_public_path__ + "media/images/bg/headers/test-229da59c14b8006c6d6352e087ff569a.jpg";